"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preContentMarginRight = exports.chipItemMarginBottom = exports.chipItemMarginRight = exports.localText = void 0;
exports.localText = {
    more: 'More',
    less: 'Less',
    numberMore: function (number) { return "+".concat(number); },
};
exports.chipItemMarginRight = 8;
exports.chipItemMarginBottom = 8;
exports.preContentMarginRight = 12;
